import type {
    MissingInformationDTO,
    ContentMissingInformationDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation';
import { Grid, GridItem, TextField, CprField } from '@flos/react-ui';
import React from 'react';
import { useSetRecoilState } from 'recoil';
import { missingInformationAtom } from '../../../recoil/atoms/missingInformationAtom';

const ContentMissingInformationForm = ({
    contentMissingDTO,
    flavourMissingName
}: {
    contentMissingDTO: ContentMissingInformationDTO;
    flavourMissingName: keyof MissingInformationDTO;
}): React.JSX.Element => {
    const setMissingInformation = useSetRecoilState(missingInformationAtom);

    const { name, surname, cpr } = contentMissingDTO;
    const fixedId = contentMissingDTO.fixedId ?? '';

    const updateMissingInformationProperty = (updateValue: ContentMissingInformationDTO): void => {
        setMissingInformation((previousState) => {
            const updateDto = previousState[flavourMissingName]?.map(
                (item: ContentMissingInformationDTO) => {
                    if (item.fixedId !== fixedId) return item;
                    return {
                        ...item,
                        ...updateValue
                    };
                }
            );
            return {
                ...previousState,
                [flavourMissingName]: updateDto
            };
        });
    };

    return (
        <>
            <React.Fragment key={fixedId}>
                <Grid gap={'none'}>
                    <GridItem span={12}>
                        <Grid gap={3}>
                            <GridItem span={6}>
                                <TextField
                                    label={'Fornavn'}
                                    id={`${flavourMissingName}-missing-name-${fixedId}`}
                                    defaultValue={name}
                                    pattern="[ a-zA-Z\u00C0-\u017F'-]+"
                                    minLength={1}
                                    maxLength={32}
                                    onBlur={(data) => {
                                        updateMissingInformationProperty({
                                            name: data.currentTarget.value
                                        });
                                    }}
                                    showLength={false}
                                />
                            </GridItem>
                            <GridItem span={6}>
                                <TextField
                                    label={'Efternavn'}
                                    id={`${flavourMissingName}-missing-surname-${fixedId}`}
                                    defaultValue={surname}
                                    pattern="[a-zA-Z\u00C0-\u017F'-]+"
                                    minLength={1}
                                    maxLength={32}
                                    onBlur={(data) => {
                                        updateMissingInformationProperty({
                                            surname: data.currentTarget.value
                                        });
                                    }}
                                    showLength={false}
                                />
                            </GridItem>
                        </Grid>
                    </GridItem>
                    <GridItem span={12}>
                        <CprField
                            label={'CPR-nummer'}
                            id={`${flavourMissingName}-missing-cpr-${fixedId}`}
                            value={cpr}
                            onBlur={(data) => {
                                updateMissingInformationProperty({
                                    cpr: data.target.value.replace(/\D/g, '')
                                });
                            }}
                        />
                    </GridItem>
                </Grid>
            </React.Fragment>
        </>
    );
};
export default ContentMissingInformationForm;
